export default __webpack_public_path__ + "static/media/chevron-right.b4fc4f1d.svg";